(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledCircularChart', {
            templateUrl: 'app/components/styled-circular-chart/styled-circular-chart.html',
            controller: styledCircularChartController,
            bindings: {
                content: '=',
                percentage: '=',
                size: '@',
                lightStyle: '<',
                successOnFull: '<'
            }
        });

    /** @ngInject */
    function styledCircularChartController($scope) {
        var ctrl = this;

        ctrl.$onInit = function () {
            switch (ctrl.size) {
                case 'xs':
                    ctrl.chartSize = '45px';
                    break;
                case 'sm':
                    ctrl.chartSize = '65px';
                    break;
                default:
                    ctrl.chartSize = '100px';

            }
        };

        $scope.$watch(
            function () { return ctrl.percentage; }
        );
    }
})();
